import clsx from 'clsx'
import { format } from 'date-fns'

import { useParams, useSearchParams } from 'react-router-dom'

import DotsSvg from '@/assets/img/dots.svg'
import Dropdown from '@/compoments/common/Dropdown'
import UserPart from '@/compoments/common/UserPart'
import DropdownList from '@/compoments/DropdownList'
import HeaderDataViewFilter from '@/compoments/HeaderDataViewFilter'
import PageLoader from '@/compoments/PageLoader'

import {
    enumPillStatusesClasses,
    enumPillStatusesText,
} from '@/types/tenant/workGroup.types'
import { useGetDispatcherTechnicianTasksQuery } from '@/services/dispatcher/dispather'

export const TaskList = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const { id } = useParams()
    const { data, isLoading } = useGetDispatcherTechnicianTasksQuery(
        { id: Number(id), query: `no_limit=true&${searchParams.toString()}` },
        { skip: !id },
    )
    const pageData = data?.data

    if (isLoading) return <PageLoader />
    if (!data) return null
    return (
        <>
            <div
                className="tab flex-auto active-tab overflow-hidden"
                data-id="task-list"
            >
                <HeaderDataViewFilter />
                <div className="table-body table-responsive p-0 flex-auto">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Task</th>
                                <th style={{ width: '250px' }}>Address</th>
                                <th>Client</th>
                                <th>Status</th>
                                <th style={{ width: '10px' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pageData?.tasks && pageData.tasks.length > 0 ? (
                                pageData.tasks.map((task, index) => (
                                    <tr key={index}>
                                        <td>
                                            {format(
                                                new Date(task.startTime),
                                                'MM dd, yyyy',
                                            )}
                                        </td>
                                        <td>
                                            {format(
                                                new Date(task.startTime),
                                                'hh:mm a',
                                            )}
                                        </td>
                                        <td>{task.service.name}</td>
                                        <td className="text--12 text-color-1 text-wrap">{`${task.address.street}, ${task.address.city}, ${task.address.state} ${task.address.postalCode}, ${task.address.country}`}</td>
                                        <td>
                                            <UserPart
                                                src={task.customer.photo}
                                                name={task.customer.fullName}
                                                email={task.customer.email}
                                            />
                                        </td>

                                        <td>
                                            <span
                                                className={clsx(
                                                    'pill',
                                                    enumPillStatusesClasses[
                                                        task.status
                                                    ],
                                                )}
                                            >
                                                {
                                                    enumPillStatusesText[
                                                        task.status
                                                    ]
                                                }
                                            </span>
                                        </td>
                                        <td className="text-right sticky-end">
                                            <Dropdown
                                                closeSelf={true}
                                                dropdownClasses="flex flex-col"
                                                button={
                                                    <span className="ico">
                                                        <img
                                                            src={DotsSvg}
                                                            alt=""
                                                        />
                                                    </span>
                                                }
                                                menuClassName="dropdown-md"
                                                menu={
                                                    <DropdownList list={[]} />
                                                }
                                            />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={7}>
                                        <h4 className="text-center">
                                            Tasks not found
                                        </h4>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
